import React from 'react';
import styled, { keyframes, css } from 'styled-components';

const lyricsFlyIn = keyframes`
  0% { opacity: 0; transform: translateY(12px) rotate(var(--r)); }
  100% { opacity: 1; transform: translateY(0) rotate(var(--r)); }
`;

const lyricsFadeOut = keyframes`
  0% { opacity: 1; transform: translateY(0) rotate(var(--r)); }
  100% { opacity: 0; transform: translateY(-8px) rotate(var(--r)); }
`;

const LyricsOverlayEl = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  pointer-events: none;
`;

const LyricFly = styled.span`
  position: absolute;
  left: ${(p) => p.$x}%;
  top: ${(p) => p.$y}%;
  transform: rotate(${(p) => p.$rotation}deg);
  --r: ${(p) => p.$rotation}deg;
  color: #e9ecf1;
  font-size: 1rem;
  line-height: 1.4;
  white-space: nowrap;
  text-shadow:
    0 0 4px rgba(0,0,0,0.9),
    0 1px 3px rgba(0,0,0,0.8),
    0 2px 6px rgba(0,0,0,0.6);
  animation:
    ${css`${lyricsFlyIn} 0.4s ease-out forwards`},
    ${css`${lyricsFadeOut} 0.5s ease-in 3.2s forwards`};
  @media (max-width: 480px) {
    font-size: 0.9rem;
    max-width: 38vw;
  }
`;

export function LyricsOverlay({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <LyricsOverlayEl aria-hidden>
      {items.map((item) => (
        <LyricFly
          key={item.id}
          $x={item.x}
          $y={item.y}
          $rotation={item.rotation}
        >
          {item.text}
        </LyricFly>
      ))}
    </LyricsOverlayEl>
  );
}
